import { enumParser } from '#validation/common/parsers';
import { PrincipalProvider, PrincipalType } from '../constants';
export const principalTypeParser = enumParser(PrincipalType);
export const principalProviderParser = enumParser(PrincipalProvider);
